/* eslint-disable no-unused-vars */
import { allComponents } from '../referential/gassienComponents'

export const nearestValue = (nb, modulo, limitLow, limitHigh) => {
  const diff = nb % modulo
  const rawNewValue = diff >= modulo / 2 ? nb + (modulo - diff) : nb - diff

  return limitLow === undefined || limitHigh === undefined ? rawNewValue
    : rawNewValue >= limitLow && rawNewValue <= limitHigh ? rawNewValue
      : rawNewValue < limitLow ? limitLow
        : rawNewValue > limitHigh ? limitHigh
          : rawNewValue
}

export const getOriginalPosition = (state, elementType) => {
  const {
    elements, res, baseRes, originalPosition,
  } = state
  const { divWidth, divHeight } = originalPosition
  const element = allComponents[elementType]
  const factor = res / baseRes
  const originX = 80
  const originY = 44
  const maxX = divWidth * factor - element.width
  const maxY = divHeight * factor - element.height

  const elementsWithoutBoxes = elements.filter((el) => el.type !== 'box')
  const elementsWithSameType = elementsWithoutBoxes
    .filter((el) => element.type === allComponents[el.type].type)

  let originalPositionX = null
  let originalPositionY = null

  let lastWidth = 0
  let lastHeight = 0

  const deltaX = (allComponents[elementType] && allComponents[elementType].type === 'board')
    ? allComponents[elementType].offsetX
    : 0


  for (let iY = originY; iY < maxY; iY += lastHeight) {
    for (let i = originX; i < maxX; i += lastWidth) {
      const isElementOnPosition = elementsWithSameType
        .filter((el) => {
          const elDeltaX = (allComponents[el.type] && allComponents[el.type].type === 'board')
            ? allComponents[el.type].offsetX
            : 0

          return ((el.x + elDeltaX) === nearestValue(i, element.type === 'grid' ? 20 : 4))
          && (el.y === nearestValue(iY, 44))
        })


      if (isElementOnPosition.length === 0) {
        originalPositionX = i
        originalPositionY = iY
        break
      } else {
        lastWidth = allComponents[isElementOnPosition[0].type].width
        lastHeight = allComponents[isElementOnPosition[0].type].height
      }
    }
    if (originalPositionX) {
      break
    }
  }

  if (!originalPositionX && !originalPositionY) {
    originalPositionX = originX
    originalPositionY = originY
  }

  return {
    originalPositionX: nearestValue(originalPositionX - deltaX, element.type === 'grid' ? 20 : 4),
    originalPositionY: nearestValue(originalPositionY, 44),
  }
}

const checkIfBoardIsOnGrid = (board, grids) => {
  const {
    x, y, width, height, id, offsetX, offsetY, offsetHeight, offsetWidth,
  } = board

  // Check if board corners are on a Grid
  const topLeft = grids
    .filter(
      (el) => (x + offsetX >= el.x && x + offsetX <= el.x + el.width)
      && (y + offsetY >= el.y && y + offsetY < el.y + el.height),
    )
    .length

  const topRight = grids
    .filter(
      (el) => (x + width - offsetWidth >= el.x && x + width - offsetWidth <= el.x + el.width)
      && (y + offsetY >= el.y && y + offsetY < el.y + el.height),
    )
    .length

  const bottomLeft = grids
    .filter(
      (el) => (x + offsetX >= el.x && x + offsetX <= el.x + el.width)
      && ((y + height - offsetHeight) >= el.y && (y + height - offsetHeight) < el.y + el.height),
    )
    .length

  const bottomRight = grids
    .filter(
      (el) => (x + width - offsetWidth >= el.x && x + width - offsetWidth <= el.x + el.width)
      && ((y + height - offsetHeight) >= el.y && (y + height - offsetHeight) < el.y + el.height),
    )
    .length
  return topLeft === 0 || topRight === 0 || bottomLeft === 0 || bottomRight === 0
}

const checkCollision = (element, elements) => {
  const {
    x, y, width, height, id, offsetX, offsetY, offsetWidth, offsetHeight,
  } = element

  const collisions = elements.filter((el) => {
    if (
      el.id === id
      || (x + width <= el.x + el.offsetX)
        || (x + offsetX >= el.x + el.width)
        || (y + height - offsetHeight <= el.y + el.offsetY)
        || (y + offsetY >= el.y + el.height - el.offsetHeight)

    ) {
      return false
    }
    return true
  })

  return collisions.length > 0
}

const checkGridsCollision = (grids) => {
  const gridsWithDimensions = grids
    .map((grid) => (
      {
        ...grid,
        width: allComponents[grid.type].width,
        height: allComponents[grid.type].height,
        offsetX: 0,
        offsetY: 0,
        offsetHeight: 0,
        offsetWidth: 0,
      }
    ))
  const gridsWithCollision = gridsWithDimensions
    .map(((grid) => ({
      ...grid,
      collision: checkCollision(
        {
          ...grid,
          offsetX: 0,
          offsetY: 0,
          offsetHeight: 0,
          offsetWidth: 0,
        },
        gridsWithDimensions,
      ),
    })))

  return gridsWithCollision
}

const checkBoardsCollision = (boards, grids) => {
  const boardsWithDimensions = boards
    .map((board) => (
      {
        ...board,
        width: allComponents[board.type].width,
        height: allComponents[board.type].height,
        offsetX: allComponents[board.type].offsetX || 0,
        offsetY: allComponents[board.type].offsetY || 0,
        offsetWidth: allComponents[board.type].offsetWidth || 0,
        offsetHeight: allComponents[board.type].offsetHeight || 0,
      }
    ))

  const gridsWithDimensions = grids
    .map((grid) => (
      {
        ...grid,
        width: allComponents[grid.type].width,
        height: allComponents[grid.type].height,
        offsetX: 0,
        offsetY: 0,
        offsetWidth: 0,
        offsetHeight: 0,
      }
    ))
  const boardsWithCollision = boardsWithDimensions
    .map(((board) => ({
      ...board,
      collision: checkCollision(
        {
          ...board,
          offsetX: allComponents[board.type].offsetX || 0,
          offsetY: allComponents[board.type].offsetY || 0,
          offsetWidth: allComponents[board.type].offsetWidth,
          offsetHeight: allComponents[board.type].offsetHeight,
        },
        boardsWithDimensions,
      ) || checkIfBoardIsOnGrid(
        {
          ...board,
          offsetX: allComponents[board.type].offsetX || 0,
          offsetY: allComponents[board.type].offsetY || 0,
          offsetWidth: allComponents[board.type].offsetWidth,
          offsetHeight: allComponents[board.type].offsetHeight,
        },
        gridsWithDimensions,
      ),
    })))

  return boardsWithCollision
}

export const checkElementsInCollision = (elements) => {
  const grids = elements.filter((el) => allComponents[el.type] && allComponents[el.type].type === 'base')
  const boards = elements.filter((el) => allComponents[el.type] && allComponents[el.type].type === 'board')
  const accessories = elements.filter((el) => allComponents[el.type] && allComponents[el.type].type === 'accessories')
  const boxes = elements.filter((el) => el.type === 'box')
  return [
    ...checkGridsCollision(grids),
    ...checkBoardsCollision(boards, grids),
    ...accessories,
    ...boxes,
  ]
}

export const calculateWholeDimensions = (grids, baseRes, res) => {
  const factor = baseRes / res

  const minX = grids.reduce((acc, cur) => (acc < 0 || (cur.x < acc) ? cur.x : acc), -1)
  const minY = grids.reduce((acc, cur) => (acc < 0 || (cur.y < acc) ? cur.y : acc), -1)

  const maxX = (grids.reduce((acc, cur) => (
    acc < 0 || ((cur.x + cur.width) > acc) ? (cur.x + cur.width) : acc
  ),
  -1)) - minX

  const maxY = grids.reduce((acc, cur) => (
    acc < 0 || ((cur.y + cur.height) > acc) ? (cur.y + cur.height) : acc
  ),
  -1) - minY

  const wholeWidth = Math.round(maxX / 4)
  const wholeHeight = Math.round(maxY / 4)

  return {
    minX: minX * factor,
    minY: minY * factor,
    maxX: maxX * factor,
    maxY: maxY * factor,
    wholeWidth,
    wholeHeight,
  }
}
